/**
 * Coreg
 * Functionality for coreg pages using AdOcto
 * 
 * Config Options
 * -- rdrBaseUrl : Redirect URL passed into AdOcto
 * -- track1 : Track1 override
 * -- sid : SID override
 */
define('components/coreg',[
    "jquery",
    "logging",
    "utilities",
    "storage"
], function($, logging, utilities, storage) {
    "use strict";

    var _ModuleName = "CoReg (AdOcto)";
    var _config = {
        tracking: {
            name: "track01"
        },
        storage: {
            prepend: "autofill-"
        }
    };
    var _data = {
        track1: "",
        sid: "",
        rdr: ""
    };

    var init = function(data) {
        logging.debug("Initializing", _ModuleName);
        _data.rdr = data.rdrBaseUrl;
        _data.track1 = data.track1 ||  "";
        _data.sid = data.sid || "";
    }

    var run = function() {
        logging.debug("Running CoReg Script (AdOcto)", _ModuleName);

        var $frame = $('#aoframe');
        if($frame) {
            // Pull track1 from URL
            _data.track1 = _data.track1 || utilities.getParameter(document.URL, "track1");

            // If we couldn't get anything via track1, try SID
            if(!_data.track1) {
                _data.track1 = _data.sid || utilities.getParameter(document.URL, "SID");
            }

            // Set SID the same as track1
            _data.sid = _data.track1;

            // Store data in session
            utilities.setTrackingValue(_config.tracking.name, _data.track1);

            var iframeUrl = $frame.attr('src');
            var rdrUrl = _data.rdr + (_data.rdr.indexOf('?') < 0 ? '?' : '&')
                + 'track1=' + _data.track1;

            var email = _getData('email') || _getData('gifts-email') || _getData('gifts-email-real'),
                first = _getData('first') || _getData('first_name') || _getData('gifts-first'),
                last = _getData('last') || _getData('last_name') || _getData('gifts-last');
            logging.debug('RDR URL: ' + rdrUrl, _ModuleName);
            iframeUrl += (iframeUrl.indexOf('?') < 0 ? '?' : '&')
                + 'track1=' + _data.track1 + '&'
                + 'SID=' + _data.sid + '&'
                + 'rdr=' + encodeURIComponent(rdrUrl)
                + (email ? '&email=' + email : '')
                + (first ? '&first=' + first : '')
                + (last ? '&last=' + last : '');
            
            logging.debug('iFrame URL: ' + iframeUrl, _ModuleName);
            $frame.attr('src', iframeUrl);

            logging.debug("Completed iFrame URL Updates", _ModuleName);
        } else {
            logging.error("Unable to locate AdOcto iFrame", _ModuleName);
        }
    }

    var _getData = function(name) {
        var data = utilities.getParameter(document.URL, name);
        if(!data) {
            data = storage.getLocalStorage(_config.storage.prepend + name);
        }

        // Saves a copy before returning it so it can be used again later (in case it was pulled from the URL)
        return _saveData(name, data);
    }

    var _saveData = function(name, value) {
        if(value) {
            storage.setLocalStorage(_config.storage.prepend + name, value);
        }
        return value;
    }

    return {
        init: init,
        run: run
    }
});
